module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/new-748c193d01468aec46fcd55d927d9349.png";